import { Component, OnInit } from '@angular/core';
import { LgpdService } from '@app/services/lgpd.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AutenticacaoService } from '@app/services/autenticacao.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-termo-lgpd',
  templateUrl: './termo-lgpd.component.html'
})
export class TermoLgpdComponent implements OnInit {

  termoLGPDHtml: SafeHtml = '';

  formTermoSistema: FormGroup;

  mostrarCheckbox = true;

  constructor(
    private lgpdService: LgpdService,
    private autenticacaoService: AutenticacaoService,
    private _sanitizer: DomSanitizer,
    private _formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {

    this.verificarTermoUsuario();

    this.buildForm();
    this.carregarTermoSistema();
  }

  aceitarTermo(value) {
    if (value !== '' && value !== false) {
      this.formTermoSistema.patchValue({
        // tslint:disable-next-line: max-line-length
        idTipoAcao: value ? '65891a94-5c15-41af-94d2-b6d1db5d20fa' : 'a805d063-2234-4c46-acc4-8f81e1ae198c'
      });

      // const urlRetorno = this.activatedRoute.snapshot.queryParams.urlRetorno;
      // const urlRetornoDecoded = decodeURI(urlRetorno);
      // const [urlString, queryString] = urlRetornoDecoded.split('?');
      // const query = new URLSearchParams(queryString);
      // const queryRetorno: any = {};
      // if (query.has('idVaga')) queryRetorno.idVaga = query.get('idVaga');
      // if (query.has('idInscricao')) queryRetorno.idInscricao = query.get('idInscricao');
      // if (query.has('fazerRedacao')) queryRetorno.fazerRedacao = query.get('fazerRedacao');

      this.lgpdService.aceitarTermoUsuario(this.formTermoSistema.value).subscribe(
        result => {
          const urlRetorno = this.activatedRoute.snapshot.queryParams.urlRetorno || '/vagas/lista';
          // this.router.navigate([urlString], { queryParams: queryRetorno });
          this.router.navigate([urlRetorno]);
        }
      );
    }
  }

  carregarTermoSistema() {
    this.lgpdService.carregarTermoSistema('PORTAL_CANDIDATO', 'TERMO_DADOS_PESSOAIS').subscribe(
      result => {
        this.termoLGPDHtml = this._sanitizer.bypassSecurityTrustHtml(result.html);
      }
    );
  }

  verificarTermoUsuario() {
    this.autenticacaoService.verificarTermoUsuario(this.autenticacaoService.getValorUsuarioAtualCandidato.cpf, 'PORTAL_CANDIDATO', 'TERMO_DADOS_PESSOAIS')
    .subscribe(
      result => {
        if (result) {
          this.mostrarCheckbox = false;
        }
      }
    );
  }

  getControl(field, form) { return this[form].get(field); }

  buildForm() {
    this.formTermoSistema = this._formBuilder.group({
      idTipoAcao: ['', Validators.required],
      idTipoTermo: ['f3c8168a-61a9-45be-95e6-ccafd2213ca4', Validators.required],
      idSistema: ['1e9efca3-668e-4b56-90aa-9c524fdee579', Validators.required],
      cpf: [this.autenticacaoService.getValorUsuarioAtualCandidato.cpf, Validators.required],
    });
  }
}
